import { CardCheckbox } from "@/components/PreferenceCard";

export interface CardCheckboxOption {
  name: string;
  title: string;
  description?: string;
}

interface CardCheckboxGroupFieldProps {
  label: string;
  hint?: string;
  required?: boolean;
  options: CardCheckboxOption[];
  values: Record<string, boolean>;
  onToggle: (name: string) => void;
  error?: string;
}

/**
 * A list of independently-toggleable CardCheckbox cards, one per boolean field
 * (as opposed to a single array-valued multi-select). Used where each option
 * maps to its own flag rather than membership in a shared list.
 */
export const CardCheckboxGroupField = ({
  label,
  hint,
  required,
  options,
  values,
  onToggle,
  error,
}: CardCheckboxGroupFieldProps) => (
  <div data-field className="flex flex-col gap-2">
    <label className="label">
      {label} {required && <span className="text-required-star">*</span>}{" "}
      {hint && <span className="text-theme-text-muted">{hint}</span>}
    </label>
    <div className="flex flex-col gap-3">
      {options.map((option) => (
        <CardCheckbox
          key={option.name}
          selected={!!values[option.name]}
          onToggle={() => onToggle(option.name)}
          title={option.title}
          description={option.description}
        />
      ))}
    </div>
    {error && (
      <p data-field-error className="error-message">
        {error}
      </p>
    )}
  </div>
);
